import Scheduler from "./Scheduler";
import styles from "./styles.module.scss";

const COO = () => {
  return (
    <div className={styles.cooWrapper}>
      <Scheduler styleGrid={styles.schedullerGrid} />
    </div>
  );
};

export default COO;
